import { Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { EStorageType } from '@pichincha/angular-sdk/auth'
import { storage } from '@pichincha/angular-sdk/storage'
import { EVENT_NAMES } from '../../utils/events'
import { environment } from '../../../environments/environment'

@Injectable()
export class AuthenticatedGuard implements CanActivate {
  storage = storage({
    storageType: EStorageType.SESSION,
    secretKey: environment.storage.key,
  })

  constructor(private router: Router) {}

  canActivate(): boolean {
    const authenticated = !!(this.storage.get(EVENT_NAMES.auth) || undefined)

    if (!authenticated) this.router.navigate(['/'], { replaceUrl: true })
    return authenticated
  }
}
